import { CustomFieldType } from 'src/app/+shared/custom-fields/models/enums/customFieldType';
import { ApplicationSectionKeys, AllLabels } from 'src/app/constants/app.constants';
import { HeatingDeviceObject } from 'src/app/jurisdiction/facilities-form/facilities-form.domain';
import { AllDropdownKeys } from 'src/app/jurisdiction/jurisdiction.constants';

const districtHeatType = {
  name: 'dhType',
  label: 'facilities-data.form-fields.dh_type',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Dropdown,
  dropdownTypeKey: AllDropdownKeys.HeatingDistributionType,
};

const districtTypeOfHeating = {
  name: 'dhTypeHeating',
  label: 'facilities-data.form-fields.dh_type_heating',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Dropdown,
  dropdownTypeKey: AllDropdownKeys.HeatingTypeOfHeating,
  required: true,
};

const heatingLoad = {
  name: 'heatingLoad',
  label: 'facilities-data.form-fields.heating_load',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  required: true,
  type: CustomFieldType.Number,
  units: AllLabels.units.power,
};

const installHeatPower = {
  name: 'installHeatPower',
  label: 'facilities-data.form-fields.inst_heat_power',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  units: AllLabels.units.power,
  required: true,
};

const floorHeating = {
  name: 'floorHeating',
  label: 'facilities-data.form-fields.floor_heating',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  displayFunction: (value: HeatingDeviceObject) => value.dhTypeHeating === 'hybrid',
  columnOffset: 6,
};

const dhw = {
  name: 'dhw',
  label: 'facilities-data.form-fields.dhw',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Switch,
  required: true,
};

const designTempTv = {
  name: 'designTempTv',
  label: 'facilities-data.form-fields.design_temp_tv',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  units: AllLabels.units.temperature,
  hint: 'facilities-data.form-fields.hint_text_tv',
  required: true,
};

const designTempTr = {
  name: 'designTempTr',
  label: 'facilities-data.form-fields.design_temp_tr',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  units: AllLabels.units.temperature,
  hint: 'facilities-data.form-fields.hint_text_tr',
  columnOffset: 6,
  required: true,
};

const designTempFloorHeatingTv = {
  name: 'designTempFloorHeatingTv',
  label: 'facilities-data.form-fields.design_temp_floor_heating_tv',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  displayFunction: (value: HeatingDeviceObject) => value.dhw && value.dhTypeHeating === 'hybrid',
};

const designTempFloorHeatingTr = {
  name: 'designTempFloorHeatingTr',
  label: 'facilities-data.form-fields.design_temp_floor_heating_tr',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  displayFunction: (value: HeatingDeviceObject) => value.dhTypeHeating === 'hybrid',
};

const thermoValveType = {
  name: 'thermoValveType',
  label: 'facilities-data.form-fields.thermo_valve_type',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Text,
  displayFunction: (value: HeatingDeviceObject) => value.dhTypeHeating === 'hybrid' || value.dhTypeHeating === 'radiator',
};

const flowRadiators = {
  name: 'flowRadiators',
  label: 'facilities-data.form-fields.flow_radiators',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  displayFunction: (value: HeatingDeviceObject) => value.dhTypeHeating === 'hybrid' || value.dhTypeHeating === 'radiator',
};

const deviation = {
  name: 'deviation',
  label: 'facilities-data.form-fields.deviation',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  displayFunction: (value: HeatingDeviceObject) => value.dhTypeHeating === 'hybrid' || value.dhTypeHeating === 'radiator',
};

const flowFloorHeating = {
  name: 'flowFloorHeating',
  label: 'facilities-data.form-fields.flow_floor_heating',
  section: ApplicationSectionKeys.technicalData.districtHeatDevice,
  type: CustomFieldType.Number,
  units: AllLabels.units.volumeFlowRate,
  displayFunction: (value: HeatingDeviceObject) => value.dhTypeHeating === 'hybrid' || value.dhTypeHeating === 'floor',
};

export default {
  districtHeatType,
  districtTypeOfHeating,
  heatingLoad,
  installHeatPower,
  floorHeating,
  dhw,
  designTempTv,
  designTempTr,
  designTempFloorHeatingTv,
  designTempFloorHeatingTr,
  thermoValveType,
  flowRadiators,
  deviation,
  flowFloorHeating,
};
